import React from 'react'

import { Text } from './styles'

const Footer = () => <Text>Saúde Preventiva • Versão 1.21.8</Text>

export default Footer
